function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6963 18.2695C11.3555 18.2695 11.8213 17.751 12.1289 16.9512L17.6396 2.53711C17.7803 2.17676 17.8506 1.85156 17.8506 1.5791C17.8506 0.963867 17.4639 0.568359 16.8398 0.568359C16.5674 0.568359 16.2422 0.647461 15.8818 0.788086L1.41504 6.31641C0.685547 6.59766 0.149414 7.05469 0.149414 7.72266C0.149414 8.53125 0.74707 8.84766 1.57324 9.10254L5.7832 10.3945C6.38965 10.5791 6.75 10.5703 7.18945 10.1748L16.5146 1.56152C16.6377 1.45605 16.7783 1.46484 16.8662 1.55273C16.9629 1.64062 16.9717 1.79004 16.8574 1.91309L8.27051 11.2471C7.90137 11.6514 7.86621 12.0469 8.04199 12.6533L9.30762 16.793C9.5625 17.6455 9.8877 18.2695 10.6963 18.2695Z",
  fill: "#697185"
});

var SvgPaperAirplane = function SvgPaperAirplane(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperAirplane, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paper-airplane.d1284ace.svg";
export { ForwardRef as ReactComponent };